<template>
    <main id="profile" v-if="!loading">
        
        
        
        <article>
            
            <!-- 
                TODO - FIX inline <a href="#"></a>
                https://forum.vuejs.org/t/dynamically-compile-router-link/7410/6
                https://alligator.io/vuejs/v-runtime-template/
            -->
            <div class="summary" v-html="summary"></div>
            
            <div class="profile" v-html="profile">
                <!-- <h2>Our approach:</h2>
                <p>We are 50 creatives with different areas of expertise. We always believe in having the best man and woman on the job, which is why every project we embark on, generates a new constellation and team. Explorers, pushing boundaries, we are most comfortable when we are breaking new ground. Because for us, branding is an ever changing field, that demands creative freedom to develop the right solution for the right time.</p>
                
                <h2>Our areas:</h2>
                <p>We work from idea to reality, and believe in delivering a full brand experience. Our comprehensive teams act in two stages; building a creative concept, then bringing that concept to life - be it digitally, spatially or through print. </p>
                
                <h2>Our work:</h2>
                <p>We work with a wide variety of companies and organisations - ranging from local to international, corporate to lifestyle and cultural to institutional. We are proud to have been part of creating, strengthening and rejuvenating every one of these brands. If you want to know more, feel free to contact us and we’ll take it from there.</p>
                
                <h3>Our prominent fields are:</h3>
                <ul>
                    <li><a href="/work/brand-strategy">Brand Strategy</a></li>
                    <li><a href="/work/visual-identity">Visual Identity</a></li>
                    <li><a href="/work/communication">Communication</a></li>
                    <li><a href="/work/spatial-branding">Spatial Branding & Interiors</a></li>
                    <li><a href="/work/digital-strategy">Digital Strategy</a></li>
                    <li><a href="/work/digital-identity">Digital Identity</a></li>
                    <li><a href="/work/digital-development">Digital Development</a></li>
                    <li><a href="/work/graphical-design">Graphical Design</a></li>
                    <li><a href="/work/publications-magazines">Publications & Magazines</a></li>
                    <li><a href="/work/brand-guidelines">Brand Guidelines</a></li>
                </ul> -->
            </div>
            
            <MediaImage v-if="!loading" :data="image" @loaded="imageLoaded" />
            
        </article>
        
        
        <Footer />

        <SecondaryNavigation :text="this.$router.currentRoute.name" :showCloseIcon="false" />
        
    </main>
</template>

<script>
import axios from 'axios'
import SecondaryNavigation from '@/components/SecondaryNavigation.vue'
import Footer from '@/components/Footer'
import MediaImage from '@/components/MediaImage'

export default {
    components: {
        SecondaryNavigation,
        MediaImage,
        Footer
    },
    
    data() {
        return {
            loading: true,
			summary: '',
            profile: '',
            image: {},
        }
    },
    
    created() {
        
    },
    
    mounted() {
        this.getData()
    },
    
    methods: {
        
		getData() {
			let url = "/data/profile.json"

            this.loading = true
            
			return axios
				.get(url)
				.then(res => {
					this.summary = res.data.summary
                    this.profile = res.data.profile
                    this.image = res.data.image
                    this.loading = false
                    
                    this.$emit('loaded') // Tell App data is ready
				})
				.catch(error => {
                    throw new Error('Data Failed: ', error);
                })
        },
        
        imageLoaded() {
        },
        
    }
}
</script>

<style lang="scss" scoped>

@import '../scss/variables';
@import '../scss/font-scaling';



#profile {
    @include page-padding;

    article {
        position: relative;
        
        .summary,
        .profile {
            @media (min-width: $tablet) {
                margin-left: calc(3 / 24 * 100%);
                margin-right: calc(3 / 24 * 100%);
                
            }
        }
        
        
        .summary {
            max-width: 660px;
            ::v-deep p {
                font-size: 13px; // TODO 
                line-height: 1.4em;
                
                
                // @media (min-width: $phablet) {
                //     @include FluidFontStart(768, 1600, 12, 16);
                //     @include FluidFontEndless(1600, 16, .4);
                // }
            }
        }
        
        .profile {
            margin-top: 12%;
            
            // https://vue-loader.vuejs.org/guide/scoped-css.html#deep-selectors
            ::v-deep h2, 
            ::v-deep p, 
            ::v-deep a {
                font-size: 22px;
                line-height: 1.4em;
                font-weight: 400;
                
                @media (min-width: $tablet) {
                    @include FluidFontStart(1024, 1440, 26, 26);
                    @include FluidFontStart(1440, 3400, 26, 62);
                    @include FluidFontEndless(3400, 62, 0.4);
                }
            }
            
            ::v-deep h2 {
                margin-top: 6%;
            }
            
            ::v-deep h3 {
                margin-top: 12%;
                font-size: 13px;
                line-height: 1.4em;
                font-weight: 400;
                padding-bottom: 10px;
                
                
                // @media (min-width: $phablet) {
                //     @include FluidFontStart(768, 1600, 12, 16);
                //     @include FluidFontEndless(1600, 16, .4);
                // }
            }
            
            ::v-deep p {
                text-indent: 2em; // first line indent
            }
            
            ::v-deep a {
                &:hover {
                    text-decoration: line-through;
                }
            }
            
        }
        
        .media-image {
            margin-top: 12%;
        }
    }
}
</style>
